import styled from 'styled-components'
import { mq } from '../../styles/mq'
import { ParagraphContainer } from '../../components/container'

export const Container = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;
`

export const Section = styled.section.attrs({ className: 'section' })`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--background-color);

  > div {
    width: 100%;
  }
`

export const SectionWrapper = styled.div`
  width: 100%;
`

export const TallContent = styled(SectionWrapper)`
  max-width: 170vh;
  margin: 0 auto;
`

export const Columns = styled(ParagraphContainer)`
  ${mq.medium} {
    max-width: none;
    column-width: 20em;
    max-height: 90vh;
    column-gap: 5em;

    p:first-child {
      margin-top: 0;
    }

    p:last-child {
      margin-bottom: 0;
    }
  }

  ${mq.large} {
    column-count: 3;
    max-width: 100em;
  }
`

export const Centered = styled.div`
  text-align: center;
`

export const LargeText = styled.div`
  max-width: 905px;
  width: 100%;

  p {
    font-size: 1.9rem;

    ${mq.medium} {
      font-size: 2.5rem;
    }

    ${mq.large} {
      font-size: 3.2rem;
    }

    ${mq.xlarge} {
      font-size: 3.5rem;
    }
  }
`
